import { FormattedMessage } from 'react-intl';

export const mobileMenuLinks = [
    {
        type: "link",
        label: <FormattedMessage id="departments.healthandpersonalcare" defaultMessage="Health and Personal Care" />,
        url: "",
        children: [
            {
                type: "link",
                label: <FormattedMessage id="departments.personalcare" defaultMessage="Personal Care" />,
                url: "/shop/catalog/personal-care",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.haircare" defaultMessage="Hair Care" />, url: "/shop/catalog/hair-care" },
                    { type: "link", label: <FormattedMessage id="departments.oralcare" defaultMessage="Oral Care" />, url: "/shop/catalog/oral-care" },
                    { type: "link", label: <FormattedMessage id="departments.skincare" defaultMessage="Skin Care" />, url: "/shop/catalog/skin-care" },
                    { type: "link", label: <FormattedMessage id="departments.bathandbody" defaultMessage="Bath & Body" />, url: "/shop/catalog/bath-body" },
                    { type: "link", label: <FormattedMessage id="departments.shavingandgrooming" defaultMessage="Shaving & Grooming" />, url: "/shop/catalog/shaving-grooming" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.medicalsupplies" defaultMessage="Medical Supplies" />,
                url: "/shop/catalog/medical-supplies",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.bracesandsupports" defaultMessage="Braces & Supports" />, url: "/shop/catalog/braces-supports" },
                    { type: "link", label: <FormattedMessage id="departments.mobilityaids" defaultMessage="Mobility Aids" />, url: "/shop/catalog/mobility-aids" },
                    { type: "link", label: <FormattedMessage id="departments.bandagesanddressing" defaultMessage="Bandages & Dressing" />, url: "/shop/catalog/bandages-dressings" },
                    { type: "link", label: <FormattedMessage id="departments.thermometers" defaultMessage="Thermometers" />, url: "/shop/catalog/thermometers" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.babyhealth" defaultMessage="Baby Health" />,
                url: "/shop/catalog/baby-health",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.diapers" defaultMessage="Diapers" />, url: "/shop/catalog/diapers" },
                    { type: "link", label: <FormattedMessage id="departments.babyskincare" defaultMessage="Baby Skincare" />, url: "/shop/catalog/baby-skincare" },
                    { type: "link", label: <FormattedMessage id="departments.babymedicine" defaultMessage="Baby Medicine" />, url: "/shop/catalog/baby-medicine" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.fitnessandwellness" defaultMessage="Fitness & Wellness" />,
                url: "/shop/catalog/fitness-wellness",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.yogapilates" defaultMessage="Yoga & Pilates" />, url: "/shop/catalog/yoga-pilates" },
                    { type: "link", label: <FormattedMessage id="departments.weighttraining" defaultMessage="Weight Training" />, url: "/shop/catalog/weight-training" },
                    { type: "link", label: <FormattedMessage id="departments.cardioequipment" defaultMessage="Cardio Equipment" />, url: "/shop/catalog/cardio-equipment" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.diagnosticsandtesting" defaultMessage="Diagnostics & Testing" />,
                url: "/shop/catalog/diagnostics-testing",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.bloodpressuremonitors" defaultMessage="Blood Pressure Monitors" />, url: "/shop/catalog/blood-pressure-monitors" },
                    { type: "link", label: <FormattedMessage id="departments.glucosemonitors" defaultMessage="Glucose Monitors" />, url: "/shop/catalog/glucose-monitors" },
                    { type: "link", label: <FormattedMessage id="departments.heartratesensors" defaultMessage="Heart Rate Monitors" />, url: "/shop/catalog/heart-rate-monitors" },
                ],
            },
            { type: "link", label: <FormattedMessage id="departments.vitaminsandsupplements" defaultMessage="Vitamins & Supplements" />, url: "/shop/catalog/vitamins-supplements" },
            { type: "link", label: <FormattedMessage id="departments.healthdevices" defaultMessage="Health Devices" />, url: "/shop/catalog/health-devices" },
            { type: "link", label: <FormattedMessage id="departments.firstaid" defaultMessage="First Aid" />, url: "/shop/catalog/first-aid" },
            { type: "link", label: <FormattedMessage id="departments.eyecare" defaultMessage="Eye Care" />, url: "/shop/catalog/eye-care" },
        ],
    },

    {
        type: "link",
        label: <FormattedMessage id="departments.homandkitchen" defaultMessage="Home and Kitchen" />,
        url: "/shop/catalog/home-and-kitchen",
        children: [
            {
                type: "link",
                label: <FormattedMessage id="departments.kitchenappliances" defaultMessage="Kitchen Appliances" />,
                url: "/shop/catalog/kitchen-appliances",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.blenders" defaultMessage="Blenders" />, url: "/shop/catalog/blenders" },
                    { type: "link", label: <FormattedMessage id="departments.microwaves" defaultMessage="Microwaves" />, url: "/shop/catalog/microwaves" },
                    { type: "link", label: <FormattedMessage id="departments.ovens" defaultMessage="Ovens" />, url: "/shop/catalog/ovens" },
                    { type: "link", label: <FormattedMessage id="departments.toasters" defaultMessage="Toasters" />, url: "/shop/catalog/toasters" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.cookware" defaultMessage="Cookware" />,
                url: "/shop/catalog/cookware",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.potsandpans" defaultMessage="Pots & Pans" />, url: "/shop/catalog/pots-pans" },
                    { type: "link", label: <FormattedMessage id="departments.cookingutensils" defaultMessage="Cooking Utensils" />, url: "/shop/catalog/cooking-utensils" },
                    { type: "link", label: <FormattedMessage id="departments.bakingtools" defaultMessage="Baking Tools" />, url: "/shop/catalog/baking-tools" },
                    { type: "link", label: <FormattedMessage id="departments.pressurecookers" defaultMessage="Pressure Cookers" />, url: "/shop/catalog/pressure-cookers" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.homeorganization" defaultMessage="Home Organization" />,
                url: "/shop/catalog/home-organization",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.storagebins" defaultMessage="Storage Bins" />, url: "/shop/catalog/storage-bins" },
                    { type: "link", label: <FormattedMessage id="departments.closetorganizers" defaultMessage="Closet Organizers" />, url: "/shop/catalog/closet-organizers" },
                    { type: "link", label: <FormattedMessage id="departments.shelvingunits" defaultMessage="Shelving Units" />, url: "/shop/catalog/shelving-units" },
                    { type: "link", label: <FormattedMessage id="departments.laundrybaskets" defaultMessage="Laundry Baskets" />, url: "/shop/catalog/laundry-baskets" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.homedecor" defaultMessage="Home Decor" />,
                url: "/shop/catalog/home-decor",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.wallart" defaultMessage="Wall Art" />, url: "/shop/catalog/wall-art" },
                    { type: "link", label: <FormattedMessage id="departments.rugs" defaultMessage="Rugs" />, url: "/shop/catalog/rugs" },
                    { type: "link", label: <FormattedMessage id="departments.curtains" defaultMessage="Curtains" />, url: "/shop/catalog/curtains" },
                    { type: "link", label: <FormattedMessage id="departments.mirrors" defaultMessage="Mirrors" />, url: "/shop/catalog/mirrors" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.cleaningsupplies" defaultMessage="Cleaning Supplies" />,
                url: "/shop/catalog/cleaning-supplies",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.vacuumcleaners" defaultMessage="Vacuum Cleaners" />, url: "/shop/catalog/vacuum-cleaners" },
                    { type: "link", label: <FormattedMessage id="departments.mopsandbuckets" defaultMessage="Mops & Buckets" />, url: "/shop/catalog/mops-buckets" },
                    { type: "link", label: <FormattedMessage id="departments.brooms" defaultMessage="Brooms" />, url: "/shop/catalog/brooms" },
                    { type: "link", label: <FormattedMessage id="departments.dustpans" defaultMessage="Dust Pans" />, url: "/shop/catalog/dust-pans" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.lighting" defaultMessage="Lighting" />,
                url: "/shop/catalog/lighting",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.tablelamps" defaultMessage="Table Lamps" />, url: "/shop/catalog/table-lamps" },
                    { type: "link", label: <FormattedMessage id="departments.ceilinglights" defaultMessage="Ceiling Lights" />, url: "/shop/catalog/ceiling-lights" },
                    { type: "link", label: <FormattedMessage id="departments.floorlamps" defaultMessage="Floor Lamps" />, url: "/shop/catalog/floor-lamps" },
                    { type: "link", label: <FormattedMessage id="departments.outdoorlights" defaultMessage="Outdoor Lights" />, url: "/shop/catalog/outdoor-lights" },
                ],
            },
        ],
    },

    {
        type: "link",
        label: <FormattedMessage id="departments.petsupplies" defaultMessage="Pet Supplies" />,
        url: "",
        children: [
            {
                type: "link",
                label: <FormattedMessage id="departments.foodandtreats" defaultMessage="Food & Treats" />,
                url: "/shop/catalog/food-treats",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.dogfood" defaultMessage="Dog Food" />, url: "/shop/catalog/dog-food" },
                    { type: "link", label: <FormattedMessage id="departments.catfood" defaultMessage="Cat Food" />, url: "/shop/catalog/cat-food" },
                    { type: "link", label: <FormattedMessage id="departments.birdfood" defaultMessage="Bird Food" />, url: "/shop/catalog/bird-food" },
                    { type: "link", label: <FormattedMessage id="departments.smallpettreats" defaultMessage="Small Pet Treats" />, url: "/shop/catalog/small-pet-treats" },
                ],
            },

            {
                type: "link",
                label: <FormattedMessage id="departments.pettoys" defaultMessage="Pet Toys" />,
                url: "/shop/catalog/pet-toys",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.dogtoys" defaultMessage="Dog Toys" />, url: "/shop/catalog/dog-toys" },
                    { type: "link", label: <FormattedMessage id="departments.cattoys" defaultMessage="Cat Toys" />, url: "/shop/catalog/cat-toys" },
                    { type: "link", label: <FormattedMessage id="departments.birdtoys" defaultMessage="Bird Toys" />, url: "/shop/catalog/bird-toys" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.petaccessories" defaultMessage="Pet Accessories" />,
                url: "/shop/catalog/pet-accessories",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.collarsandleashes" defaultMessage="Collars & Leashes" />, url: "/shop/catalog/collars-leashes" },
                    { type: "link", label: <FormattedMessage id="departments.petbeds" defaultMessage="Pet Beds" />, url: "/shop/catalog/pet-beds" },
                    { type: "link", label: <FormattedMessage id="departments.petcarrierstravel" defaultMessage="Carriers & Travel" />, url: "/shop/catalog/pet-carriers-travel" },
                    { type: "link", label: <FormattedMessage id="departments.bowlsandfeeders" defaultMessage="Bowls & Feeders" />, url: "/shop/catalog/bowls-feeders" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.groomingandhealth" defaultMessage="Grooming & Health" />,
                url: "/shop/catalog/grooming-health",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.groomingtools" defaultMessage="Grooming Tools" />, url: "/shop/catalog/grooming-tools" },
                    { type: "link", label: <FormattedMessage id="departments.healthsupplements" defaultMessage="Health Supplements" />, url: "/shop/catalog/health-supplements" },
                    { type: "link", label: <FormattedMessage id="departments.cleaningsupplies" defaultMessage="Cleaning Supplies" />, url: "/shop/catalog/pet-cleaning-supplies" },
                    { type: "link", label: <FormattedMessage id="departments.litterandwastedisposal" defaultMessage="Litter & Waste Disposal" />, url: "/shop/catalog/litter-waste-disposal" },
                ],
            },
        ],
    },

    {
        type: "link",
        label: <FormattedMessage id="departments.toysandgames" defaultMessage="Toys & Games" />,
        url: "",
        children: [
            {
                type: "link",
                label: <FormattedMessage id="departments.buildingsetsandblocks" defaultMessage="Building Sets & Blocks" />,
                url: "/shop/catalog/building-sets-blocks",
                children: [
                    { type: "link", label: <FormattedMessage id="departments.lego" defaultMessage="LEGO" />, url: "/shop/catalog/lego" },
                    { type: "link", label: <FormattedMessage id="departments.megabloks" defaultMessage="Mega Bloks" />, url: "/shop/catalog/mega-bloks" },
                    { type: "link", label: <FormattedMessage id="departments.woodenblocks" defaultMessage="Wooden Blocks" />, url: "/shop/catalog/wooden-blocks" },
                    { type: "link", label: <FormattedMessage id="departments.stemkits" defaultMessage="STEM Kits" />, url: "/shop/catalog/stem-kits" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.actionfiguresanddolls" defaultMessage="Action Figures & Dolls" />,
                url: "/shop/catalog/action-figures-dolls",
                size: 6,
                children: [
                    { type: "link", label: <FormattedMessage id="departments.superheroes" defaultMessage="Superheroes" />, url: "/shop/catalog/superheroes" },
                    { type: "link", label: <FormattedMessage id="departments.dolls" defaultMessage="Dolls" />, url: "/shop/catalog/dolls" },
                    { type: "link", label: <FormattedMessage id="departments.collectiblefigures" defaultMessage="Collectible Figures" />, url: "/shop/catalog/collectible-figures" },
                    { type: "link", label: <FormattedMessage id="departments.plustoy" defaultMessage="Plush Toys" />, url: "/shop/catalog/plush-toys" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.gamesandpuzzles" defaultMessage="Games & Puzzles" />,
                url: "/shop/catalog/games-puzzles",
                size: 6,
                children: [
                    { type: "link", label: <FormattedMessage id="departments.boardgames" defaultMessage="Board Games" />, url: "/shop/catalog/board-games" },
                    { type: "link", label: <FormattedMessage id="departments.cardgames" defaultMessage="Card Games" />, url: "/shop/catalog/card-games" },
                    { type: "link", label: <FormattedMessage id="departments.jigsawpuzzles" defaultMessage="Jigsaw Puzzles" />, url: "/shop/catalog/jigsaw-puzzles" },
                    { type: "link", label: <FormattedMessage id="departments.strategygames" defaultMessage="Strategy Games" />, url: "/shop/catalog/strategy-games" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.outdoorplay" defaultMessage="Outdoor Play" />,
                url: "/shop/catalog/outdoor-play",
                size: 6,
                children: [
                    { type: "link", label: <FormattedMessage id="departments.swingsets" defaultMessage="Swing Sets" />, url: "/shop/catalog/swing-sets" },
                    { type: "link", label: <FormattedMessage id="departments.playtents" defaultMessage="Play Tents" />, url: "/shop/catalog/play-tents" },
                    { type: "link", label: <FormattedMessage id="departments.watertoys" defaultMessage="Water Toys" />, url: "/shop/catalog/water-toys" },
                    { type: "link", label: <FormattedMessage id="departments.sportsequipment" defaultMessage="Sports Equipment" />, url: "/shop/catalog/sports-equipment" },
                ],
            },
        ],
    },

    {
        type: "link",
        label: <FormattedMessage id="departments.toolsandhomeimprovement" defaultMessage="Tools - Home Improvement" />,
        url: "",
        children: [
            {
                type: "link",
                label:  <FormattedMessage id="departments.solderingequipment" defaultMessage="Soldering Equipment" />,
                url: "/shop/catalog/soldering-equipment",
                children: [
                    {type: "link", label: <FormattedMessage id="departments.solderingstation" defaultMessage="Soldering Station" />, url: "/shop/catalog/soldering-station" },
                    {type: "link", label: <FormattedMessage id="departments.solderingdryers" defaultMessage="Soldering Dryers" />, url: "/shop/catalog/soldering-dryers" },
                    {type: "link", label: <FormattedMessage id="departments.gas" defaultMessage="Gas Soldering Iron" />, url: "/shop/catalog/gas-soldering-iron" },
                    {type: "link", label: <FormattedMessage id="departments.electricsolderingiron" defaultMessage="Electric Soldering Iron" />, url: "/shop/catalog/electric-soldering-iron" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.electricalandlighting" defaultMessage="Electrical & Lighting" />,
                url: "/shop/catalog/electrical-lighting",
                children: [
                    {type: "link", label: <FormattedMessage id="departments.lightbulbs" defaultMessage="Light Bulbs" />, url: "/shop/catalog/light-bulbs" },
                    {type: "link", label: <FormattedMessage id="departments.lightfixtures" defaultMessage="Light Fixtures" />, url: "/shop/catalog/light-fixtures" },
                    {type: "link", label: <FormattedMessage id="departments.warmfloor" defaultMessage="Warm Floor" />, url: "/shop/catalog/warm-floor" },
                    {type: "link", label: <FormattedMessage id="departments.generators" defaultMessage="Generators" />, url: "/shop/catalog/generators" },
                    {type: "link", label: <FormattedMessage id="departments.ups" defaultMessage="UPS" />, url: "/shop/catalog/ups" },
                ],
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.powersources" defaultMessage="Power Sources" />,
                url: "/shop/catalog/power-sources",
                children: [
                    {type: "link", label: <FormattedMessage id="departments.batteries" defaultMessage="Batteries" />, url: "/shop/catalog/batteries" },
                    {type: "link", label: <FormattedMessage id="departments.solarpanels" defaultMessage="Solar Panels" />, url: "/shop/catalog/solar-panels" },
                    {type: "link", label: <FormattedMessage id="departments.extensioncords" defaultMessage="Extension Cords" />, url: "/shop/catalog/extension-cords" },
                ],
            },
        ],
    },

    {
        type: "link",
        label: <FormattedMessage id="departments.officeproducts" defaultMessage="Office Products" />,
        url: "",
        children: [
            {
                type: "link",
                label: <FormattedMessage id="departments.writinganddrawing" defaultMessage="Writing & Drawing" />,
                url: "/shop/catalog/writing-drawing",
                children: [
                    {type: "link", label: <FormattedMessage id="departments.pens" defaultMessage="Pens" />, url: "/shop/catalog/pens" },
                    {type: "link", label: <FormattedMessage id="departments.pencils" defaultMessage="Pencils" />, url: "/shop/catalog/pencils" },
                    {type: "link", label: <FormattedMessage id="departments.markers" defaultMessage="Markers" />, url: "/shop/catalog/markers" },
                    {type: "link", label: <FormattedMessage id="departments.highlighters" defaultMessage="Highlighters" />, url: "/shop/catalog/highlighters" }
                ]
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.paperandnotebooks" defaultMessage="Paper & Notebooks" />,
                url: "/shop/catalog/paper-notebooks",
                children: [
                    {type: "link", label: <FormattedMessage id="departments.notebooks" defaultMessage="Notebooks" />, url: "/shop/catalog/notebooks" },
                    {type: "link", label: <FormattedMessage id="departments.printerpaper" defaultMessage="Printer Paper" />, url: "/shop/catalog/printer-paper" },
                    {type: "link", label: <FormattedMessage id="departments.stickynotes" defaultMessage="Sticky Notes" />, url: "/shop/catalog/sticky-notes" },
                    {type: "link", label: <FormattedMessage id="departments.journals" defaultMessage="Journals" />, url: "/shop/catalog/journals" }
                ]
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.officesupplies" defaultMessage="Office Supplies" />,
                url: "/shop/catalog/office-supplies",
                children: [
                    {type: "link", label: <FormattedMessage id="departments.organizers" defaultMessage="Organizers" />, url: "/shop/catalog/organizers" },
                    {type: "link", label: <FormattedMessage id="departments.staplers" defaultMessage="Staplers" />, url: "/shop/catalog/staplers" },
                    {type: "link", label: <FormattedMessage id="departments.paperclips" defaultMessage="Paper Clips" />, url: "/shop/catalog/paper-clips" },
                    {type: "link", label: <FormattedMessage id="departments.tapedispensers" defaultMessage="Tape Dispensers" />, url: "/shop/catalog/tape-dispensers" }
                ]
            },
            {
                type: "link",
                label: <FormattedMessage id="departments.officeelectronics" defaultMessage="Office Electronics" />,
                url: "/shop/catalog/office-electronics",
                children: [
                    {type: "link", label: <FormattedMessage id="departments.printers" defaultMessage="Printers" />, url: "/shop/catalog/printers" },
                    {type: "link", label: <FormattedMessage id="departments.scanners" defaultMessage="Scanners" />, url: "/shop/catalog/scanners" },
                    {type: "link", label: <FormattedMessage id="departments.laminators" defaultMessage="Laminators" />, url: "/shop/catalog/laminators" },
                    {type: "link", label: <FormattedMessage id="departments.calculators" defaultMessage="Calculators" />, url: "/shop/catalog/calculators" }
                ]
            }
        ],
    },

    {type: "link", label: <FormattedMessage id="departments.sportsandoutdoors" defaultMessage="Sports and Outdoors" />, url: ''},
    {type: "link", label: <FormattedMessage id="departments.automotive" defaultMessage="Automotive" />, url: ''},
    {type: "link", label: <FormattedMessage id="departments.electronics" defaultMessage="Electronics" />, url: ''},
    {type: "link", label: <FormattedMessage id="departments.seasonal" defaultMessage="Seasonal" />, url: '' },
    {type: "link", label: <FormattedMessage id="departments.everythingelse" defaultMessage="Everything Else" />, url: ''},
];
